import { useState, type ReactNode } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'

type CollapsibleCardProps = {
  icon: ReactNode
  iconBgClass?: string
  title: string
  subtitle?: string
  defaultOpen?: boolean
  collapsedAsRow?: boolean
  children: ReactNode
}

const CollapsibleCard = ({
  icon,
  iconBgClass = 'bg-primary-50 text-primary-600',
  title,
  subtitle,
  defaultOpen = true,
  collapsedAsRow = false,
  children,
}: CollapsibleCardProps) => {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <section className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-3 px-4 sm:px-5 py-4 text-left hover:bg-gray-50/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-1"
      >
        <div className="flex items-center gap-3 min-w-0">
          <span
            className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${iconBgClass}`}
          >
            {icon}
          </span>
          <div className="min-w-0">
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 truncate">
              {title}
            </h3>
            {subtitle && (
              <p className="text-xs sm:text-sm text-gray-500 truncate">{subtitle}</p>
            )}
          </div>
        </div>
        <span className="text-gray-400 shrink-0">
          {open ? (
            <ChevronDown size={18} />
          ) : collapsedAsRow ? (
            <ChevronRight size={18} />
          ) : (
            <ChevronDown size={18} />
          )}
        </span>
      </button>
      {open && (
        <div className="border-t border-gray-100 px-4 sm:px-5 py-4 sm:py-5">{children}</div>
      )}
    </section>
  )
}

export default CollapsibleCard
